import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import home from "assets/images/svgs/home-breadcrumb.svg";
import arrow from "assets/images/svgs/breadcrumb-arrow.svg";
import useStore from "hooks/useStore";
import { GENDERS } from "utils/helpers/enums/shared.enum";
import { siteRoutes } from "utils/helpers/enums/routes";

interface BreadcrumbProps {
  links: MinorBreadcrumbLink[];
}

export interface MinorBreadcrumbLink {
  title: string;
  path: string;
  state?: any;
}

const MinorBreadcrumb: FC<BreadcrumbProps> = ({ links }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { getUser } = useStore();
  const { user = null } = getUser();

  const handleNavigation = (link: MinorBreadcrumbLink) => {
    const { path: route = "", state = null } = link;
    if (route.split("?")[0] === pathname) return;
    navigate(route, { state });
  };

  return (
    <div className="flex items-center gap-2 flex-wrap py-2 sm:py-4">
      <img
        src={home}
        alt="Home"
        className="cursor-pointer"
        onClick={() => navigate(siteRoutes.minorHome)}
      />
      <img src={arrow} alt="Arrow" className="mx-2" />
      {links.map((link, index) => {
        return (
          <div key={index} className="flex items-center">
            {index > 0 && <img src={arrow} alt="Arrow" className="mx-2" />}
            <span
              className={`text-sm font-normal cursor-pointer ${
                pathname === link.path.split("?")[0]
                  ? `${
                      user?.gender === GENDERS.MALE
                        ? "text-minorBoy"
                        : "text-minorGirl"
                    }`
                  : "text-lightgray-medium"
              }`}
              onClick={() => handleNavigation(link)}
            >
              {link.title}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default MinorBreadcrumb;
